import { useTranslations } from "@ui/providers/useTranslations";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";

import { CategoryCheckbox } from "./components/CategoryCheckbox";

import styles from "./CategoryFilters.module.scss";

export type CategoryFiltersProps = {
  subcategories: {
    uid: string;
    name: string;
    checked: boolean;
    image: string;
    productCount?: number;
    newBadge?: string;
  }[];
  handleChange: (uid: string) => void;
  isProductCountVisible?: boolean;
  discontinuedProductName?: string | null;
};

export function CategoryFilters({
  subcategories,
  handleChange,
  isProductCountVisible = false,
  discontinuedProductName,
}: CategoryFiltersProps) {
  const { __ } = useTranslations();

  return (
    <div className={styles.wrapper}>
      {discontinuedProductName && (
        <AlertBanner
          tone="warning"
          isDismissible
          dismissLabel="Close"
          title={__("discontinued.product.banner.title", [discontinuedProductName])}
          description={__("discontinued.product.banner.description")}
        />
      )}

      <ul className={styles.list}>
        {subcategories?.map((subcategory) => {
          const { productCount, name, newBadge } = subcategory;
          const categoryLabel = isProductCountVisible && productCount ? `${name} (${productCount})` : name;

          return (
            <li key={subcategory.uid} className={styles.listItem}>
              <label className={styles.label}>
                <CategoryCheckbox
                  label={categoryLabel}
                  checked={subcategory.checked}
                  onChange={() => handleChange(subcategory.uid)}
                  className={styles.checkbox}
                  image={subcategory.image}
                  newBadge={newBadge}
                />
              </label>
            </li>
          );
        })}
      </ul>

      {discontinuedProductName && (
        <p className={styles.discontinuedText}>{__("discontinued.product.similar.products")}</p>
      )}
    </div>
  );
}
